import { adminInstance } from "@/api/instance";

export default async function (rectureId) {
  return adminInstance.patch(`/lecture/${rectureId}`);
}
